.padlockCard {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--cxy-spacing-5);
  padding: var(--cxy-spacing-4);
  border: 1px solid #49697d;
}

[data-fpsm-theme='whoscored'] .padlockCard {
  border: 1px solid var(--cxy-color-grey-750);
}

@media (min-width: 801px) {
  .padlockCard {
    min-height: 500px;
  }
}

.padlock {
  width: 30px;
  color: var(--cxy-color-brand);
}
@media (min-width: 801px) {
  .padlock {
    width: 48px;
  }
}

.contentWrapper {
  display: flex;
  flex-direction: column;
  gap: var(--cxy-spacing-4);
}
@media (min-width: 801px) {
  .contentWrapper {
    gap: var(--cxy-spacing-3);
  }
}

.title {
  font-family: var(--cxy-font-family-futura);
  color: var(--cxy-color-brand);
  font-size: 22px;
  font-weight: var(--cxy-fontWeight-extraBold);
  line-height: 26px;
  text-transform: uppercase;
  text-align: center;
}
.title span {
  font-size: inherit;
  font-weight: inherit;
  font-family: inherit;
  line-height: inherit;
  white-space: nowrap;
}
@media (min-width: 801px) {
  .title {
    font-size: 32px;
    line-height: 36px;
  }
}

.text {
  font-size: var(--cxy-fontSize-s);
  font-weight: var(--cxy-fontWeight-semiBold);
  line-height: var(--cxy-lineHeight-l);
  text-align: center;
  max-width: 580px;
  margin: 0 auto;
}

.ghostButton,
.loginText {
  font-size: var(--cxy-fontSize-s);
  font-weight: var(--cxy-fontWeight-semiBold);
  line-height: var(--cxy-lineHeight-l);
  text-align: center;
}

.ctaWrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: var(--cxy-spacing-2);
  width: 100%;
}
.ctaWrapper .text {
  display: inline-flex;
  align-items: center;
  gap: var(--cxy-spacing-0);
}

.loginText {
  text-align: center;
}
.loginText button {
  margin-top: calc(-1 * var(--cxy-spacing-1));
}

.button {
  width: 100%;
  text-transform: uppercase;
}
@media (min-width: 801px) {
  .button {
    width: 312px;
  }
}

.link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  white-space: nowrap;
  vertical-align: middle;
  background-color: var(--cxy-color-brand);
  color: var(--cxy-color-content-dark);
  border-width: 0px;
  border-radius: var(--cxy-border-radius-button);
  cursor: pointer;
  padding-inline: var(--cxy-spacing-8);
  font-weight: var(--cxy-fontWeight-bold);
  line-height: var(--cxy-lineHeight-s);
  font-size: var(--cxy-fontSize-m);
  text-transform: uppercase;
}

[data-fpsm-theme='gazzetta'] .link {
  font-size: var(--cxy-fontSize-s);
}

@media (min-width: 801px) {
  .link {
    width: 312px;
  }
}

.mainButton {
  background-color: var(--cxy-color-content-dark);
  color: var(--cxy-color-content-default);
}
@media (min-width: 801px) {
  .mainButton {
    background-color: var(--cxy-color-brand);
    color: var(--cxy-color-content-dark);
  }
}

.ghostButton {
  color: var(--cxy-color-brand);
  text-decoration: underline;
  margin: 0;
}

.mobileView {
  display: inline-flex;
}
@media (min-width: 801px) {
  .mobileView {
    display: none;
  }
}

.globalPaywallCard {
  background: linear-gradient(135deg, #022e4a 0%, #022e4a 40%, #4b2b5c 65%, #5b3164 85%, #672b6e 100%);
  background: -webkit-linear-gradient(315deg, #022e4a 0%, #022e4a 40%, #4b2b5c 65%, #5b3164 85%, #672b6e 100%);
  background: -moz-linear-gradient(315deg, #022e4a 0%, #022e4a 40%, #4b2b5c 65%, #5b3164 85%, #672b6e 100%);
  background: -o-linear-gradient(315deg, #022e4a 0%, #022e4a 40%, #4b2b5c 65%, #5b3164 85%, #672b6e 100%);
  border-radius: var(--cxy-border-radius-m);
  padding: var(--cxy-spacing-4);
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.globalPaywallCard::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0) 100%);
  pointer-events: none;
}
.globalPaywallCard .content {
  padding: var(--cxy-spacing-4);
  display: flex;
  flex-direction: column;
  gap: var(--cxy-spacing-2);
  align-items: center;
}

/* WhoScored-specific paywall styling */
.wsPaywallCard {
  background: linear-gradient(
    135deg,
    var(--cxy-color-container-default) 0%,
    var(--cxy-color-container-inverse) 60%,
    var(--cxy-color-grey-800) 100%
  );
  border-radius: var(--cxy-border-radius-m);
  padding: var(--cxy-spacing-4);
  position: relative;
  overflow: hidden;
  border: none;
}
.wsPaywallCard::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(30, 182, 0, 0.03) 0%, rgba(87, 220, 28, 0.01) 50%, transparent 100%);
  pointer-events: none;
}
.wsPaywallCard .content {
  padding: var(--cxy-spacing-4);
  display: flex;
  flex-direction: column;
  gap: var(--cxy-spacing-2);
  align-items: center;
  position: relative;
  z-index: var(--cxy-z-index-internal-base);
}
.wsPaywallCard .content .title {
  color: var(--cxy-color-content-default);
  text-align: center;
}
.wsPaywallCard .content .title span {
  color: var(--cxy-color-brand);
}
.wsPaywallCard .content .text {
  color: var(--cxy-color-content-default);
  text-align: center;
}
.wsPaywallCard .content .loginText {
  color: var(--cxy-color-content-default);
}

/* WhoScored-specific template overrides */
[data-template='whoscored'] .contentWrapper {
  max-width: 790px;
  width: 100%;
}
[data-template='whoscored'] .title {
  text-align: left;
}
[data-template='whoscored'] .text {
  text-align: left;
  margin: 0;
  max-width: none;
}
[data-template='whoscored'] .itemsList {
  align-items: flex-start;
}

/* Gazzetta theme overrides */
[data-fpsm-theme='gazzetta'] {
  .contentWrapper {
    max-width: 760px;
    width: 100%;
  }

  .padlockCard {
    border: 1px solid var(--cxy-color-container-extra);
  }

  .link {
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
  }

  .itemsList {
    gap: var(--cxy-spacing-2);
    margin-bottom: var(--cxy-spacing-3);

    .itemIconWrapper {
      background: var(--cxy-color-brand);
    }
    .itemCheckIcon {
      color: var(--cxy-color-white);
    }
  }

  .text {
    text-align: left;
    margin-bottom: var(--cxy-spacing-3);
    max-width: unset;
  }

  .title {
    text-align: left;
    text-transform: unset;
  }

  @media (min-width: 801px) {
    .link {
      width: auto;
    }
  }
}
